(() => {
  const root = document.querySelector('.amie-static-page.route-supplements[data-static-handle="supplements"]');
  if (!root) return;

  const categoryByChip = {
    all: 'all',
    hormones: 'women-health',
    energy: 'energy',
    sleep: 'mood',
    focus: 'energy',
    gut: 'gut',
    immunity: 'immune',
    joints: 'recovery'
  };

  const alias = {
    supplements: 'all',
    'all-supplements': 'all',
    'womens-health': 'women-health',
    'women-health': 'women-health',
    'energy-vitality': 'energy',
    'mood-stress': 'mood',
    'gut-detox': 'gut',
    'immune-foundation': 'immune',
    'body-recovery': 'recovery',
    recovery: 'recovery',
    immune: 'immune',
    gut: 'gut',
    mood: 'mood',
    energy: 'energy'
  };

  const normalize = (value) => {
    const key = String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    return alias[key] || key || 'all';
  };

  const sections = Array.from(root.querySelectorAll('.cat-section[id]'));
  const chips = Array.from(root.querySelectorAll('.fb-chip'));
  const tiles = Array.from(root.querySelectorAll('.cat-tile[href^="#"]'));

  chips.forEach((chip) => {
    if (!chip.dataset.filter) {
      const label = normalize(chip.textContent.replace(/\(.*/, ''));
      chip.dataset.filter = categoryByChip[label] || label;
    }
    chip.type = 'button';
    chip.setAttribute('aria-pressed', chip.classList.contains('active') ? 'true' : 'false');
  });

  tiles.forEach((tile) => {
    const filter = normalize(tile.getAttribute('href').replace('#', ''));
    tile.dataset.filter = filter;
    tile.addEventListener('click', (event) => {
      event.preventDefault();
      applyFilter(filter, { scroll: true, updateUrl: true });
    });
  });

  function activeLabel(filter) {
    const map = {
      all: 'All Supplements',
      'women-health': "Women's Health Supplements",
      energy: 'Energy & Vitality Supplements',
      mood: 'Mood & Stress Supplements',
      gut: 'Gut & Detox Supplements',
      immune: 'Immune & Foundation Supplements',
      recovery: 'Body & Recovery Supplements'
    };
    return map[filter] || 'All Supplements';
  }

  function applyFilter(filter, options = {}) {
    const next = normalize(filter);
    sections.forEach((section) => {
      const match = next === 'all' || normalize(section.id) === next;
      section.dataset.supplementHidden = match ? 'false' : 'true';
      section.classList.toggle('is-filtered-in', match && next !== 'all');
    });

    chips.forEach((chip) => {
      const chipFilter = normalize(chip.dataset.filter);
      const active = chipFilter === next || (next === 'all' && chipFilter === 'all');
      chip.classList.toggle('active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const crumb = root.querySelector('.crumb .cur');
    if (crumb) crumb.textContent = activeLabel(next);

    if (options.updateUrl && window.history && window.location) {
      const url = new URL(window.location.href);
      if (next === 'all') url.searchParams.delete('category');
      else url.searchParams.set('category', next);
      window.history.replaceState({}, '', url);
    }

    if (options.scroll) {
      const target = next === 'all' ? root.querySelector('.catalog') : root.querySelector(`#${CSS.escape(next)}`);
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => applyFilter(chip.dataset.filter || 'all', { updateUrl: true }));
  });

  const params = new URLSearchParams(window.location.search);
  const initial = normalize(params.get('category') || root.dataset.initialFilter || 'all');
  applyFilter(initial, { scroll: initial !== 'all' && params.has('category') });
})();
